webpackJsonp([1],{

/***/ 103:
/***/ (function(module, exports) {

module.exports = "<div id=\"app\">\n  <md-toolbar v-if=\"user\" class=\"md-dense\">\n    <h2 class=\"md-title\" style=\"flex: 1\">\n      <router-link style=\"color: #FFF;\" v-if=\"!popup\" :to=\"{ path: '/' }\">Grades</router-link>\n      <md-icon v-if=\"popup\" class=\"md-primary\" style=\"color: #FFF; cursor: pointer\" @click.prevent.native=\"$router.go(-1)\">clear</md-icon>\n    </h2>\n    <md-button @click.native=\"logout()\">\n      logout\n    </md-button>\n  </md-toolbar>\n\n  <div class=\"container\">\n    <transition name=\"transitionName\">\n      <router-view></router-view>\n    </transition>\n  </div>\n\n  <md-snackbar md-position=\"bottom center\" ref=\"snackbar\" md-duration=\"4000\">\n    <span>{{error.message}}</span>\n    <md-button class=\"md-accent\" md-theme=\"light-blue\" @click.native=\"$refs.snackbar.close()\">Dismiss</md-button>\n  </md-snackbar>\n</div>\n";

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

module.exports = "<div class=\"home\">\n  <h1>Semesters</h1>\n  <md-list>\n    <md-list-item v-for=\"(semester, i) in semesters\" :key=\"i\" :href=\"'#/semester/' + semester.id\">\n      <span>{{semester.id}}. Semester</span>\n\n      <md-button class=\"md-icon-button md-list-action\">\n        <md-icon class=\"md-primary\" @click.prevent.native=\"remove(semester)\">clear</md-icon>\n      </md-button>\n    </md-list-item>\n  </md-list>\n\n  <md-button class=\"md-raised md-primary md-icon-button\" @click.native=\"add\">\n    <md-icon>add</md-icon>\n  </md-button>\n</div>\n";

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

module.exports = "<div class=\"login\">\n    <md-button @click.native=\"googleSignIn()\" class=\"md-raised md-warn\">\n      Sign in with Google\n    </md-button>\n</div>\n";

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

module.exports = "<div id=\"mark\">\n  <h2>{{$route.params.id === 0 ? 'Add' : 'Edit'}} Grade</h2>\n  <form novalidate @submit.stop.prevent=\"submit\" v-if=\"markForm\">\n    <md-input-container>\n      <label>Grade</label>\n      <md-input type=\"number\" v-model=\"markForm.mark\"></md-input>\n    </md-input-container>\n\n    <md-input-container>\n      <label>Weighting</label>\n      <md-input type=\"number\" v-model=\"markForm.weighting\"></md-input>\n    </md-input-container>\n\n    <md-button class=\"md-raised md-primary\" type=\"submit\">Submit</md-button>\n  </form>\n</div>\n";

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

module.exports = "<div id=\"module\">\n  <h2>{{$route.params.id === 0 ? 'Add' : 'Edit'}} Module</h2>\n  <form novalidate @submit.stop.prevent=\"submit\" v-if=\"moduleForm\">\n    <md-input-container>\n      <label>Name</label>\n      <md-input v-model=\"moduleForm.name\"></md-input>\n    </md-input-container>\n\n    <md-input-container>\n      <label>Time</label>\n      <md-input v-model=\"moduleForm.time\"></md-input>\n    </md-input-container>\n\n    <md-input-container>\n      <label>Room</label>\n      <md-input v-model=\"moduleForm.room\"></md-input>\n    </md-input-container>\n\n    <md-button class=\"md-raised md-primary\" type=\"submit\">Submit</md-button>\n  </form>\n</div>\n";

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

module.exports = "<div class=\"semester\">\n  <h1>{{semester.id}}. Semester</h1>\n  <router-link :to=\"{ path: 'module/0'}\" append>\n    <md-button class=\"md-icon-button md-raised md-primary\" style=\"position: fixed; bottom: 1rem; right: 1rem; z-index:2\">\n      <md-icon>add</md-icon>\n    </md-button>\n  </router-link>\n  <md-card v-for=\"(module, index) of semester.modules\" :key=\"index\" style=\"margin-bottom: 1rem;\">\n    <md-card-header>\n      <div class=\"md-title\">{{module.name}}</div>\n      <div class=\"md-subhead\">{{module.time}} - {{module.room}}</div>\n    </md-card-header>\n\n    <md-card-expand>\n      <md-card-actions>\n        <router-link :to=\"{ path: 'module/' + module.id}\" append>\n          <md-button class=\"md-raised md-primary\">\n            Edit\n          </md-button>\n        </router-link>\n        <md-button @click.native=\"tryDelete(module)\" class=\"md-raised md-warn\">Delete</md-button>\n        <span style=\"flex: 1\"></span>\n        <md-button class=\"md-icon-button\" md-expand-trigger>\n          <md-icon>keyboard_arrow_down</md-icon>\n        </md-button>\n      </md-card-actions>\n      <md-card-content>\n        <md-list>\n          <h3>{{getAvg(module.marks)}}</h3>\n          <md-list-item v-for=\"(mark, i) of module.marks\" :key=\"i\">\n            <span>{{mark.mark}}</span>\n            <md-button class=\"md-icon-button md-list-action\" @click.native=\"deleteMark(module, mark)\">\n              <md-icon class=\"md-primary\">clear</md-icon>\n            </md-button>\n          </md-list-item>\n          <router-link :to=\"{ path: `module/${module.id}/mark`}\" append>\n            <md-button class=\"md-raised md-primary md-icon-button\">\n              <md-icon>add</md-icon>\n            </md-button>\n          </router-link>\n\n        </md-list>\n      </md-card-content>\n    </md-card-expand>\n  </md-card>\n  <md-dialog\n    md-title=\"Delete\"\n    ref=\"deleteDialog\"\n  >\n    <md-dialog-title>Delete</md-dialog-title>\n    <md-dialog-content>\n      Do you really want to delete {{deletingModule.name}}\n    </md-dialog-content>\n    <md-dialog-actions>\n      <md-button class=\"md-primary\" @click.native=\"$refs['deleteDialog'].close()\">Cancel</md-button>\n      <md-button class=\"md-primary\" @click.native=\"$refs['deleteDialog'].close(); deleteModule()\">Ok</md-button>\n    </md-dialog-actions>\n  </md-dialog>\n\n\n\n  <!--<b-table striped hover :items=\"semester.modules\" :fields=\"fields\" @row-clicked=\"selectModule($event)\">\n    <template slot=\"actions\" scope=\"item\">\n      <b-btn variant=\"warning\" size=\"sm\" @click=\"module = item.item; $root.$emit('show::modal','addSemester')\">Edit</b-btn>\n      <b-btn variant=\"danger\" size=\"sm\" @click=\"deleteModule(item.item)\">Delete</b-btn>\n    </template>\n  </b-table>\n  <b-button variant=\"success\" @click=\"$root.$emit('show::modal','addSemester')\">+</b-button>\n\n  <b-modal id=\"addSemester\" title=\"Edit Module\" @ok=\"submitModule\" @shown=\" \">\n    <form @submit.stop.prevent=\"submitModule\">\n      <b-form-input class=\"mb-2\" type=\"text\" placeholder=\"Name\" v-model=\"module.name\"></b-form-input>\n      <b-form-input class=\"mb-2\" type=\"text\" placeholder=\"Time\" v-model=\"module.time\"></b-form-input>\n      <b-form-input type=\"text\" placeholder=\"Room\" v-model=\"module.room\"></b-form-input>\n    </form>\n  </b-modal>\n\n  <div class=\"semester__details mt-4\" v-if=\"selectedModule\">\n    <h2>{{selectedModule.name}} - {{average}}</h2>\n    <b-table striped hover :items=\"selectedModule.marks\" :fields=\"moduleFields\">\n      <template slot=\"actions\" scope=\"item\">\n        <b-btn variant=\"danger\" size=\"sm\" @click=\"deleteMark(item.item)\">Delete</b-btn>\n      </template>\n    </b-table>\n    <b-button class=\"mb-2\" variant=\"success\" @click=\"$root.$emit('show::modal','addMark')\">+</b-button>\n\n    <b-modal id=\"addMark\" title=\"Edit Mark\" @ok=\"submitMark\" @shown=\" \">\n      <form @submit.stop.prevent=\"subitMark\">\n        <b-form-input class=\"mb-2\" type=\"number\" placeholder=\"Mark\" v-model=\"mark.mark\"></b-form-input>\n        <b-form-input type=\"number\" placeholder=\"Weighting\" v-model=\"mark.weighting\"></b-form-input>\n      </form>\n    </b-modal>\n  </div>-->\n</div>\n";

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

function newId(arr) {
  var max = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arr));
  return !isFinite(max) || isNaN(max) ? 1 : max + 1;
}

function fixArr(arr) {
  return arr && arr.length > 0 ? arr.filter(function (x) {
    return !!x;
  }) : [];
}

/* harmony default export */ __webpack_exports__["a"] = ({
  newId: newId,
  fixArr: fixArr
});

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export operations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var config = {
  apiKey: 'AIzaSyBDdJGt_gN7HQ_x-hmm5P3mH35vOEkHU-M',
  authDomain: 'noteapp-a9d06.firebaseapp.com',
  databaseURL: 'https://noteapp-a9d06.firebaseio.com',
  projectId: 'noteapp-a9d06',
  storageBucket: 'noteapp-a9d06.appspot.com',
  messagingSenderId: '969690445978'
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_firebase__["initializeApp"](config));

var operations = {
  set: function set(fbase, pathFunc, data) {
    var user = fbase.auth().currentUser;
    if (user) {
      return __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref(pathFunc(user.uid)).set(data);
    }
  },
  push: function push(fbase, pathFunc, data) {
    var user = fbase.auth().currentUser;
    if (user) {
      return __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref(pathFunc(user.uid)).push(data);
    }
  },
  remove: function remove(fbase, pathFunc) {
    var user = fbase.auth().currentUser;
    if (user) {
      return __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref(pathFunc(user.uid)).remove();
    }
  }
};

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(29);



var initializeAuth = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
  __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].auth().onAuthStateChanged(function (user) {
    authService.setUser(user);
    resolve(user);
  });
});

var authService = {
  user: null,
  authenticated: function authenticated() {
    return initializeAuth.then(function (user) {
      return user && !user.isAnonymous;
    });
  },
  setUser: function setUser(user) {
    this.user = user;
  },
  login: function login(email, password) {
    return __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].auth().signInWithEmailAndPassword(email, password);
  },
  logout: function logout() {
    __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].auth().signOut().then(function () {
      console.log('logout done');
    });
  }
};

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_user__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_html__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__app_html__);



/* harmony default export */ __webpack_exports__["a"] = ({
  template: __WEBPACK_IMPORTED_MODULE_1__app_html___default.a,
  name: 'app',
  data: function data() {
    return {
      error: {},
      user: null,
      popup: false,
      transitionName: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('popup', function (e) {
      _this.popup = e;
    });
    this.$bus.$on('error', function (e) {
      _this.error = e;
      _this.$refs.snackbar.open();
    });
    this.$firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.user = user;
      } else {
        _this.user = null;
      }
    });
  },

  watch: {
    '$route': function $route(to, from) {
      var toDepth = to.path.split('/').length;
      var fromDepth = from.path.split('/').length;
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
    }
  },
  methods: {
    remove: function remove(index) {
      this.errors.splice(index, 1);
    },
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_0__services_user__["a" /* authService */].logout();
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_login_login__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_semester_semester__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_home__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_module_module__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mark_mark__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_user__ = __webpack_require__(30);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/', redirect: '/home' }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_login_login__["a" /* default */],
    meta: {
      auth: false
    }
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_4__components_home_home__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/semester/:id',
    name: 'Semester',
    component: __WEBPACK_IMPORTED_MODULE_3__components_semester_semester__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/semester/:id/module/:moduleId',
    name: 'Module',
    component: __WEBPACK_IMPORTED_MODULE_5__components_module_module__["a" /* default */],
    meta: {
      auth: true
    }
  }, {
    path: '/semester/:id/module/:moduleId/mark',
    name: 'Mark',
    component: __WEBPACK_IMPORTED_MODULE_6__components_mark_mark__["a" /* default */],
    meta: {
      auth: true
    }
  }]
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_7__services_user__["a" /* authService */].authenticated().then(function (auth) {
    if (to.meta.auth && !auth) {
      next({ path: '/login' });
    } else {
      next();
    }
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_html__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_helper__ = __webpack_require__(12);




/* harmony default export */ __webpack_exports__["a"] = ({
  template: __WEBPACK_IMPORTED_MODULE_1__home_html___default.a,
  data: function data() {
    return {
      semestersRef: {},
      semesters: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$bus.$emit('popup', false);
    var user = this.$firebase.auth().currentUser;
    if (user) {
      this.semestersRef = this.$firebase.database().ref(user.uid + '/semesters');
      this.semestersRef.on('value', function (snapshot) {
        var semesters = snapshot.val();
        if (semesters && Array.isArray(semesters)) {
          _this.semesters = semesters.filter(function (s) {
            return !!s;
          });
        } else {
          var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(semesters);
          if (keys && keys.length > 0) {
            _this.semesters = [semesters[keys[0]]];
          }
        }
      });
    }
  },

  methods: {
    add: function add() {
      var id = __WEBPACK_IMPORTED_MODULE_2__services_helper__["a" /* default */].newId(this.semesters.map(function (s) {
        return s.id;
      }));
      this.semestersRef.child('/' + id).set({ id: id });
    },
    remove: function remove(semester) {
      this.semestersRef.child('/' + semester.id).remove();
    }
  }
});

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__login_html__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__login_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__login_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);



/* harmony default export */ __webpack_exports__["a"] = ({
  template: __WEBPACK_IMPORTED_MODULE_0__login_html___default.a,
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$firebase.auth().getRedirectResult().catch(function (error) {
      return _this.$bus.$emit('error', error);
    });
    this.$firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.$router.push('/home');
      }
    });
  },

  methods: {
    googleSignIn: function googleSignIn() {
      var provider = new __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth.GoogleAuthProvider();
      provider.addScope('https://www.googleapis.com/auth/plus.login');
      this.$firebase.auth().signInWithRedirect(provider);
    }
  }
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mark_html__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mark_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mark_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_helper__ = __webpack_require__(12);



/* harmony default export */ __webpack_exports__["a"] = ({
  template: __WEBPACK_IMPORTED_MODULE_0__mark_html___default.a,
  data: function data() {
    return {
      moduleRef: null,
      module: null,
      markForm: {
        mark: 0,
        weighting: 0
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$bus.$emit('popup', true);
    var semesterId = this.$route.params.id;
    var moduleId = parseInt(this.$route.params.moduleId, 10);
    var user = this.$firebase.auth().currentUser;
    this.moduleRef = this.$firebase.database().ref(user.uid + '/semesters/' + semesterId + '/modules/' + moduleId);
    this.moduleRef.on('value', function (snapshot) {
      _this.module = snapshot.val();
      _this.module.marks = __WEBPACK_IMPORTED_MODULE_1__services_helper__["a" /* default */].fixArr(_this.module.marks);
    });
  },

  methods: {
    submit: function submit() {
      var id = __WEBPACK_IMPORTED_MODULE_1__services_helper__["a" /* default */].newId(this.module.marks ? this.module.marks.map(function (s) {
        return s.id;
      }) : []);
      var mark = {
        id: id,
        mark: parseFloat(this.markForm.mark),
        weighting: parseInt(this.markForm.weighting, 10)
      };
      this.moduleRef.child('marks/' + mark.id).set(mark);
      this.$router.go(-1);
    },
    clearMark: function clearMark() {
      this.markForm = { name: '', time: '', room: '' };
    }
  }
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_html__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__module_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__module_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_helper__ = __webpack_require__(12);




/* harmony default export */ __webpack_exports__["a"] = ({
  template: __WEBPACK_IMPORTED_MODULE_1__module_html___default.a,
  data: function data() {
    return {
      semesterRef: null,
      semester: null,
      initialModuleForm: {
        id: 0,
        name: '',
        time: '',
        room: ''
      },
      moduleForm: {}
    };
  },
  created: function created() {
    var _this = this;

    this.$bus.$emit('popup', true);
    var semesterId = this.$route.params.id;
    var moduleId = parseInt(this.$route.params.moduleId, 10);
    var user = this.$firebase.auth().currentUser;
    this.semesterRef = this.$firebase.database().ref(user.uid + '/semesters/' + semesterId);
    this.semesterRef.on('value', function (snapshot) {
      _this.semester = snapshot.val();
      _this.moduleForm = _this.semester.modules.find(function (m) {
        return m && m.id === moduleId;
      }) || _this.initialModuleForm;
    });
  },

  methods: {
    submit: function submit() {
      var id = __WEBPACK_IMPORTED_MODULE_2__services_helper__["a" /* default */].newId(this.semester.modules ? this.semester.modules.map(function (s) {
        return s.id;
      }) : []);
      var module = this.moduleForm.id ? this.moduleForm : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.moduleForm, { id: id });
      this.semesterRef.child('modules/' + module.id).set(module);
      this.$router.go(-1);
    },
    clearModule: function clearModule() {
      this.moduleForm = { name: '', time: '', room: '' };
    }
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__semester_html__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__semester_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__semester_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_helper__ = __webpack_require__(12);



/* harmony default export */ __webpack_exports__["a"] = ({
  template: __WEBPACK_IMPORTED_MODULE_0__semester_html___default.a,
  data: function data() {
    return {
      semester: {},
      semesterRef: {},
      deletingModule: {}
    };
  },
  created: function created() {
    var _this = this;

    this.$bus.$emit('popup', false);
    var id = this.$route.params.id;
    var user = this.$firebase.auth().currentUser;
    if (id && user) {
      this.semesterRef = this.$firebase.database().ref(user.uid + '/semesters/' + id);
      this.semesterRef.on('value', function (snapshot) {
        var semester = snapshot.val();
        _this.semester = semester;
        _this.semester.modules = __WEBPACK_IMPORTED_MODULE_1__services_helper__["a" /* default */].fixArr(_this.semester.modules);
        _this.semester.modules.forEach(function (module) {
          module.marks = __WEBPACK_IMPORTED_MODULE_1__services_helper__["a" /* default */].fixArr(module.marks);
        });
        if (_this.selectedModule) {
          var selected = _this.semester.modules ? _this.semester.modules.find(function (m) {
            return _this.selectedModule.id === m.id;
          }) : null;
          _this.selectModule(selected);
        }
      });
    }
  },

  methods: {
    getAvg: function getAvg(marks) {
      if (marks && marks.length) {
        var fixed = __WEBPACK_IMPORTED_MODULE_1__services_helper__["a" /* default */].fixArr(marks);
        var sum = fixed.map(function (m) {
          return m.mark * m.weighting;
        }).reduce(function (a, b) {
          return a + b;
        });
        var count = fixed.map(function (m) {
          return m.weighting;
        }).reduce(function (a, b) {
          return a + b;
        });
        var average = sum / count;
        return Math.round(average * 100) / 100;
      }
      return 'No grades available';
    },
    tryDelete: function tryDelete(module) {
      this.deletingModule = module;
      this.$refs['deleteDialog'].open();
    },
    deleteModule: function deleteModule() {
      this.semesterRef.child('modules/' + this.deletingModule.id).remove();
    },
    deleteMark: function deleteMark(module, mark) {
      this.semesterRef.child('modules/' + module.id + '/marks/' + mark.id).remove();
    },
    clearMark: function clearMark() {
      this.mark = { mark: '', weighting: '' };
    }
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_firebase__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_app__ = __webpack_require__(47);

__webpack_require__(50);
__webpack_require__(49);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_material___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$firebase = __WEBPACK_IMPORTED_MODULE_3__services_firebase__["a" /* default */];

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__components_app_app__["a" /* default */] }
});

/***/ })

},[57]);


// WEBPACK FOOTER //
// static/js/app.3b9398f884f41b6a34cf.js